<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      required: true,
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<template>
  <label :class="{ 'text-error': error }">
    <div class="mb-2 font-medium">
      {{ label }}
      <span v-if="required" class="opacity-50">*</span>
    </div>
    <textarea
      v-bind="$attrs"
      class="bg-white focus:outline-none border border-gray-300 rounded input block w-full appearance-none leading-normal h-64"
      :class="{ 'border-error': error }"
      @change="onChange"
    />
  </label>
</template>
